import PropTypes from "prop-types"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import ContributorsTableGroupHead from "components/contributors-table-group-head"

function DailyDetails({ data, viewType, show, displayType, factorTable, openFactorProfile, drift, groupSort, groupOrder }) {
  return <Table>
    <ContributorsTableGroupHead {...{
      tooltipText: "% Risk",
      groupOrder,
      groupSort,
      label: `% Risk. (${viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"})`,
    }}
    />
    <ContributorsTableContent
      driftType="Risk"
      factors
      drift={drift}
      openFactorProfile={openFactorProfile}
      data={sortData(data, groupOrder)}
      show={show}
      factorTable={factorTable}
      decompositionTitle={displayType === "total" ? "% Risk Decomposition" : null}
    />
  </Table>
}

DailyDetails.propTypes = {
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayType: PropTypes.string.isRequired,
  factorTable: PropTypes.bool.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
  drift: PropTypes.object.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
}

export default DailyDetails
